function qs(selector, context = document) {
  return context?.querySelector ? context.querySelector(selector) : null
}

function qsa(selector, context = document) {
  return context?.querySelectorAll ? context.querySelectorAll(selector) : null
}

function ready(fn) {
  if (document.readyState != "loading") {
    fn()
  } else {
    document.addEventListener("DOMContentLoaded", fn)
  }
}

/*
 *   Create an El
 */
function ce({
  type = "div",
  classname = "",
  contents = [],
  props = {},
  listeners = {},
}) {
  classname = Array.isArray(classname) ? classname : [classname]
  const el = typeof type === 'object' ? type : document.createElement(type)
  el.className = classname.join(" ")
  if (!Array.isArray(contents)) contents = [contents]

  contents.forEach((c) => {
    if (c) el.append(c)
  })

  Object.keys(props).forEach((key) => {
    el.setAttribute(key, props[key])
  })

  Object.keys(listeners).forEach((key) => {
    el.addEventListener(key, listeners[key])
  })

  return el
}

/*
 *   Force Layout for animation
 */
function forceLayout() {
  return document.body.offsetTop
}

/*
 *   Load image
 */
function loadImage(src, callback) {
  const imageEl = new Image()
  const cb = () => callback(imageEl)

  imageEl.addEventListener("load", cb)
  imageEl.src = src

  return {
    image: imageEl,
    cancel: () => {
      imageEl.removeEventListener("load", cb)
    },
  }
}

/*
 *   Disable keyboard nav
 */
function disableKeyboardNav(el) {
  if (!el) return
  const tabbableChildren = qsa("a, button", el)
  el.setAttribute("tabindex", -1)
  tabbableChildren.forEach((el) => el.setAttribute("tabindex", -1))
}

/*
 *   Enable keyboard nav
 */
function enableKeyboardNav(el) {
  const tabbableChildren = qsa("a, button", el)
  el.setAttribute("tabindex", "")
  tabbableChildren.forEach((el) => el.setAttribute("tabindex", ""))
}

/*
 *   Clamp
 */
function clamp(val, min, max) {
  return Math.min(Math.max(min, val), max)
}

/*
 *   Truncate
 */
function truncate(string, maxLength) {
  if (!string) return ""
  if (string.length > maxLength) {
    return string.substring(0, maxLength) + "&hellip;"
  }

  return string
}

/*
 *   Debounce
 */
function debounce(func, timeout = 300) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

function getMostVisible(els) {
  return new Promise((resolve, reject) => {
    let observer = new IntersectionObserver((entries) => {
      let mostVisible = entries.reduce(
        (acc, curr, index) => {
          return curr.intersectionRatio > acc.intersectionRatio
            ? { index, intersectionRatio: curr.intersectionRatio }
            : acc
        },
        { intersectionRatio: 0, index: null }
      )
      observer.disconnect()
      observer = null

      resolve(mostVisible.index)
    })

    els.forEach((el) => observer.observe(el))
  })
}

function throttle(callback, wait, thisArg = null) {
  let throttled = false
  let finalTimeout = null

  return (...args) => {
    if (throttled) {
      clearTimeout(finalTimeout)
      finalTimeout = setTimeout(() => {
        throttled = false
        callback.apply(thisArg, args)
      }, wait)
    } else {
      throttled = true
      callback.apply(thisArg, args)

      setTimeout(() => {
        throttled = false
      }, wait)
    }
  }
}
